export const Portuguese = [
  ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
  ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'ç'.toUpperCase()],
  ['Z', 'X', 'C', 'V', 'B', 'N', 'M']
]
